import { VettingRequestStatusId } from '@core/typings/organization.typing';

export namespace ApplicationEligibility {
  export interface OrganizationEligibilityCheckPayload {
    applicationId: number;
    grantProgramId: number;
    grantProgramCycleId: number;
    latestVettingRequestStatusForOrg: VettingRequestStatusId;
  }
  export interface ProgramUpdateEligibilityPayload extends OrganizationEligibilityCheckPayload {
    orgIdentification: string;
    charityBucketId: string;
    clientId: number;
    latestVettingRequestStatusForOrg: VettingRequestStatusId;
  }
  export enum ApplicationEligibilityScenario {
    CopyApplication = 1,
    UpdateCycle = 2,
    OrgForProgramRouting = 3
  }

  export interface ApplicantCopyEligibilityPayload extends OrganizationEligibilityCheckPayload {
    latestVettingRequestStatusForOrg: VettingRequestStatusId;
  }
  export enum OrganizationEligibilityCheckResponse {
    // OrganizationNotInCharityBucket is used by the UI only
    OrganizationNotInCharityBucket = 0,
    OrganizationEligible = 1,
    OrganizationNotActiveInNpp = 2,
    VettingRequestAlreadyExists = 3,
    OrganizationNotValidForGrantProgramBudget = 4,
    OrganizationNotValidForRegAuth = 5,
    OrganizationLocationNotValid = 6
  }

  export interface CopyApplicationResponse {
    isEligible: boolean;
    organizationEligibilityMessage: OrganizationEligibilityCheckResponse;
    applicationId: number;
    applicationFormId: number;
  }
}
